export { default } from "./useThemeWithoutDefault.mjs";